import { unauthApi } from './unauth'; // adjust path to your unauth api file

export const applyFoundersCircleApi = unauthApi.injectEndpoints({
  endpoints: (builder) => ({
    applyFoundersCircle: builder.mutation({
      query: ({ payload }) => ({
        url: '/v2/sp/founders-circle/apply',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useApplyFoundersCircleMutation } = applyFoundersCircleApi;